const removeWrappingQuotes = (value) => {
  const trimmedValue = String(value || "").trim();
  const firstChar = trimmedValue.charAt(0);
  const lastChar = trimmedValue.charAt(trimmedValue.length - 1);

  if (
    trimmedValue.length > 1 &&
    ((firstChar === "'" && lastChar === "'") ||
      (firstChar === '"' && lastChar === '"'))
  ) {
    return trimmedValue.slice(1, -1).trim();
  }

  return trimmedValue;
};

export const getApiBaseUrl = (apiUrl = process.env.REACT_APP_API_URL) => {
  return removeWrappingQuotes(apiUrl).replace(/\/+$/, "");
};

export const API_BASE_URL = getApiBaseUrl();

export const ensureApiBaseUrl = (apiBaseUrl = API_BASE_URL) => {
  if (!apiBaseUrl) {
    throw new Error(
      "REACT_APP_API_URL no esta configurada. Definila en .env y reinicia el servidor o rebuild/redeploy."
    );
  }

  return apiBaseUrl;
};
